module.exports = __webpack_public_path__ + "img/application_icon_food_inactive.c5598779.png";